require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-mary-bergeron-switchup.json") })
        }
      }, "path---blog-author-mary-bergeron-switchup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-mary-bergeron-switchup!./.cache/json/blog-author-mary-bergeron-switchup.json
// module id = 675
// module chunks = 231608221292675